class ModuleSidebarNotMissed {
  constructor() {
    this._init();
  }

  _init() {
    const sidebar_birthday_close = document.querySelector(
      '[data-close-sidebar-not-missed]'
    );

    if (sidebar_birthday_close) {
      sidebar_birthday_close.addEventListener(
        'click',
        this._hideSidebar.bind(this)
      );
    }
  }

  _hideSidebar() {
    console.log('hide sidebar not missed');

    const sidebar_birthday = document.getElementById('sidebar-not-missed');
    if (sidebar_birthday && sidebar_birthday.classList.contains('open')) {
      sidebar_birthday.classList.remove('open');
      document.body.classList.remove('sidebar-open');
    }
  }
}

export const moduleSidebarNotMissed = new ModuleSidebarNotMissed();
